import ngAnimate from 'angular-animate'

import uiBootstrap from 'angular-ui-bootstrap'
import defaults from './defaults'

import styleErrors from './styleErrors/directive'
import compareTo from './validation/compareToDirective'
import dialog from './dialog/index'

import uiFormly from '../ui-formly/index'

import { focusFirstInputDirective, vsName as focusFirstInputDirectiveName } from './focusFirstInput'

var mod = angular.module('SlotTrak.UI',
  [
    uiBootstrap,
    ngAnimate,
    uiFormly
  ])
  .config(defaults)
  .directive('styleFormErrors', styleErrors)
  .directive('compareTo', compareTo)
  .directive(focusFirstInputDirectiveName, focusFirstInputDirective)
  .factory(dialog.vsName, dialog)

export default mod.name
